import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../settings.service';
import { LoginService } from '../login.service';

@Component({
    selector: 'app-hmo-price-list',
    templateUrl: './hmo-price-list.component.html',
    styleUrls: ['./hmo-price-list.component.scss'],
    standalone: false
})
export class HmoPriceListComponent implements OnInit {
hmo
insurance
exams=[]
error
newExam = { examId:null, examPrice: '', examPriceTwins: '', AutoIndex: null};
examsSettings: any[] = [];
  constructor(public settingsService:SettingsService,public ls:LoginService) { }

  async ngOnInit(){
    this.examsSettings = await this.getExamNames();
  }

  
  getExamTypes(){
    return this.settingsService.getDefault()
  }

  async getExamNames() {
    const exams=await this.settingsService.getExams()
    if(!Array.isArray(exams)) return []
    return exams.filter((exam)=>!exam.custom)
  }
  
  setHmo(hmo){
  this.hmo=hmo
  this.insurance=null
  this.newExam = { examId:null, examPrice: '', examPriceTwins: '', AutoIndex: null};
  }

  async setInsurance(insurance){
  this.insurance=insurance
  this.newExam = { examId:null, examPrice: '', examPriceTwins: '', AutoIndex: null};
  if(this.hmo && this.insurance){
    this.exams=await this.settingsService.getExamsPrice(null,this.hmo,this.insurance)
  }
  }

  
  
  editExam(exam) {
    exam.isEditing = true;
  }


  
  async saveChanges(exam) {
    try {
      const result = await this.settingsService.updateExamPrice(exam);
      if (result['status']=='ok') {
        this.error=false;
        exam.isEditing = false;

      }
    } catch (error) {
      console.error('Error during the update exam price details:', error);
      this.error=true
    }
  }

  
  async saveNewExam() {
    if (!this.newExam.examId ) {
      alert('Exam name is required.');
      return;
    }
    try {
    const result =await this.settingsService.saveNewExamPrice({...this.newExam},this.hmo,this.insurance)
    if (result['status']=='ok') {
      this.error=false;
      this.newExam = { examId:null, examPrice: '', examPriceTwins: '', AutoIndex: null};
      this.exams=await this.settingsService.getExamsPrice(null,this.hmo,this.insurance)
      

    }
  } catch (error) {
    console.error('Error during the save New Exam', error);
    this.error=true
  }
  }

  async deletePrice(price){
    try {
      const result = await this.settingsService.deletePrice(price);
      if (result['status']=='ok') {
        this.error=false;
        this.exams=await this.settingsService.getExamsPrice(null,this.hmo,this.insurance)
      }
    } catch (error) {
      console.error('Error during the update exam price for private:', error);
      this.error=true
    }
  }
}
